import React from "react";
import { RowColors, RowOptions } from "../TableSection/TableSection";
import { CardTable } from "../CardTable/CardTable";
import SectionsLogo from "../../assets/headings/sections.svg";
import { SectionProps } from "../../App";
import { getCourseContent } from "../../data/courseContent";
import { hideRowLinks, isReleased } from "../../data/releaseSchedule";

export class Labs extends React.Component<SectionProps> {


    render() {
        const { labsTable } = getCourseContent();
        const modifiedRows: RowOptions[] = labsTable.rows.map(row => {
            if (!isReleased(row)) {
                return {
                    ...hideRowLinks(row),
                    backgroundColor: RowColors.LOCKED,
                    locked: true
                };
            }
            return row;
        });

        return (
            <section id = 'sections' className={`anchor sections ${this.props.static ? 'static' : ''}`}>

                <div className="content-container">
                    <div className="section-heading">
                        <img className="sections-logo logo" src={SectionsLogo} alt="sections text" />
                    </div>
                    <CardTable header={labsTable.header} rows={modifiedRows}
                    titleIndex={1} resourceStartIndex={2}
                    blurb= {`Lab/section is a time to review course content in a smaller group setting and practice applying those concepts through partnered labs. Each section will meet once a week and will be led by two TAs with around 18 students, so it is also a time to work closely with and get to know some of your fellow CS15-ers.
                            A typical lab/section consists of short group check in, a fun SRC activity, and then either a presentation and some smaller group activities to review concepts or a lab.`} />
                </div>
            </section>

        );
    }
}
